// extracted by mini-css-extract-plugin
export var adjacentSlide = "_st-9";
export var arrowButtonContainer = "_st-5";
export var arrowButtonIcon = "_st-6";
export var carouselArrowButton = "_st-2";
export var carouselElementContainer = "_st-1";
export var currentSlide = "_st-8";
export var left = "_st-3";
export var otherSlide = "_st-a";
export var productCarouselContainer = "_st-0";
export var right = "_st-4";
export var sliderOverflow = "_st-7";